// @flow
import { useCallback, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { api } from 'app/api';
import { GET_WEEK, convertResult, convertParams } from 'app/common/api/requests/cabinet/dnevnik/week';
import type { ScheduleWeek, Params } from 'app/dataTypes/ScheduleWeek.types';


export default function useScheduleWeekData({ klassId, studentId, date }: Params): [ScheduleWeek, boolean] {
  const { t } = useTranslation('app');
  const [week, setWeek] = useState<ScheduleWeek>([]);
  const [loading, setLoading] = useState(true);

  const request = useCallback(async () => {
    setLoading(true);
    const res = await api.request(GET_WEEK, {
      error: t('request_dnevnik_failed'),
      params: { klassId, studentId, date },
      convertions: { convertParams, convertResult },
    });
    if (res) {
      setWeek(res);
    }
    setLoading(false);
  }, [klassId, studentId, date, t]);

  useEffect(() => {
    request();
  }, [request]);

  return [week, loading];
}
